export const FETCH_TOPICS_SUCCESS = 'FETCH_TOPICS_SUCCESS';
export const FETCH_QUIZ_SUCCESS = 'FETCH_QUIZ_SUCCESS';
export const STORE_USER_LESSON_SUCCESS = 'STORE_USER_LESSON_SUCCESS';
export const FETCH_NUDGE_SUCCESS = 'FETCH_NUDGE_SUCCESS';
export const STORE_USER_NUDGE_LESSON_SUCCESS = 'STORE_USER_NUDGE_LESSON_SUCCESS';
export const FETCH_NUDGE_DETAILS_SUCCESS = 'FETCH_NUDGE_DETAILS_SUCCESS';
export const UPDATE_NUDGE_SUCCESS = 'UPDATE_NUDGE_SUCCESS';
export const FETCH_LESSON_DETAILS_SUCCESS = 'FETCH_LESSON_DETAILS_SUCCESS';